import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { ref } from 'vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/technologies",
    name: "technologies",
    component: () =>
      import(/* webpackChunkName: "technologies" */ "../views/TechnologiesView.vue"),
  },
  {
    path: "/visual-review",
    name: "visual-review",
    component: () =>
      import(/* webpackChunkName: "visual-review" */ "../views/VisualReviewView.vue"),
  },
  {
    path: "/stores", // Ruta actualizada
    name: "stores",
    component: () =>
      import(/* webpackChunkName: "stores" */ "../views/StoresView.vue"),
  },
  {
    path: "/products", // Ruta actualizada
    name: "products",
    component: () =>
      import(/* webpackChunkName: "products" */ "../views/ProductsView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const loading = ref(false);

// Detectar el cambio de ruta
router.beforeEach((to, from, next) => {
  loading.value = true; // Activar el preloader
  next(); // Continuar con el cambio de ruta
});

router.afterEach(() => {
  loading.value = false; // Desactivar el preloader después de que la nueva página se haya cargado
});

export { router, loading };